import { Alert, Button, Form, Modal, Row } from "antd";
import { buttonStyle, fullWidthStyle, titleStyle } from "../../constants/style";
import { SubmitStatus } from "../../api/work-order-api";
import ApiContext from "../../api/context";
import { useContext, useEffect, useState } from "react";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import { Template } from "../../api/models";

type TemplateDeleteProps = {
  template?: Template,
  onClose: () => void,
  onDelete: (template: Template) => void
};

export default function (p: TemplateDeleteProps) {
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const [error, setError] = useState<string>();
  const { api } = useContext(ApiContext);
  const isSubmitting = submitStatus === SubmitStatus.Submitting;

  useEffect(() => {
    setSubmitStatus(SubmitStatus.Idle);
    setError(undefined);
  }, [p.template?.templateID]);

  return (
    <>
      <Title style={titleStyle} level={4}>Delete Template</Title>
      <Form
        layout="vertical"
        colon={false}>
        <Paragraph>
          {`Are you sure you want to delete the "${p.template!.name}" template.`}
        </Paragraph>
        <Row style={fullWidthStyle} justify="end" align="middle">
          <Button
            type="default"
            style={buttonStyle}
            onClick={p.onClose}>
            Close
          </Button>
          <Button
            danger
            type="primary"
            style={buttonStyle}
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={() => {
              setSubmitStatus(SubmitStatus.Submitting);
              api?.deleteTemplate(p.template!.templateID!).then(response => {
                if (!response.good()) {
                  throw "Bad response received.";
                }

                p.onDelete(p.template!);
              }).catch(() => {
                setError("Failed to delete the template.");
                setSubmitStatus(SubmitStatus.Idle);
              });
            }}>
            Delete
          </Button>
        </Row>
        {
          !error ? undefined :
            <>
              <Paragraph></Paragraph>
              <Alert style={fullWidthStyle} type="error" title={error} />
            </>
        }
      </Form>
    </>);
}

